import { brandPalette } from "../../../../constants/brandPalette";
import {
  Box,
  Button,
  Flex,
  Heading,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
} from "../../../../components/Models/admin-modal-theme";
import { closeAddPaymentSubject } from "../../../../modules/admin-modules/models/Actions";
import {
  addPaymentSubjectRequest,
  editPaymentSubjectRequest,
} from "../../../../modules/admin-modules/videos/Actions";

const AddPaymentSubject = ({ isAdd, data, setSelectedData }) => {
  const openChapter = useSelector((state) => state.model.isOpen35);
  const isLoading = useSelector((state) => state.videos.isLoading);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading
        fontSize="32px"
        fontWeight="800"
        color="var(--text-primary)"
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        {isAdd ? "Add payment subject" : "Edit payment subject"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="var(--text-muted)"
        textTransform="uppercase"
        letterSpacing="0.14em"
        fontWeight="700"
      >
        Name and default amount for this fee type
      </Text>
    </Box>
  );

  const onSubmit = (values) => {
    const action = () => {
      dispatch(closeAddPaymentSubject());
      setSelectedData({});
      reset();
    };
    if (isAdd) {
      const formData = new FormData();
      formData.append("name", values?.name);
      formData.append("value", values?.value);
      dispatch(addPaymentSubjectRequest(formData, action));
    } else {
      dispatch(
        editPaymentSubjectRequest({
          id: data?.id,
          formData: {
            name: values?.name,
            value: parseInt(values?.value, 10) || 0,
          },
          action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeAddPaymentSubject());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      header={header}
      closeFunc={closeFunc}
      openVar={openChapter}
      buttonTitle={null}
      isLoading={isLoading}
      buttonFunc={handleSubmit(onSubmit)}
      size="2xl"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
      hideDefaultFooter
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={6} dir="ltr" w="100%">
          <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={8} spacingY={6} alignItems="start">
            <MainInput
              label="Payment name"
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="e.g. Monthly tuition"
              register={register}
              name="name"
            />
            <MainInput
              label="Amount"
              defaultValues={data?.value}
              error={errors?.value?.message}
              placeholder="0"
              register={register}
              name="value"
              type="number"
            />
          </SimpleGrid>

          <Flex justify="flex-end" gap={6} pt={4}>
            <Button
              variant="ghost"
              color="var(--text-primary)"
              fontWeight="800"
              _hover={{ textDecoration: "underline", bg: "rgba(91, 13, 22, 0.08)" }}
              onClick={closeFunc}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bg={brandPalette.primary}
              color="white"
              borderRadius="lg"
              px={8}
              py={6}
              fontWeight="800"
              isLoading={isLoading}
              _hover={{ bg: brandPalette.accentDark }}
              boxShadow="0 10px 24px rgba(91, 13, 22, 0.18)"
            >
              Save changes
            </Button>
          </Flex>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddPaymentSubject;
